export const STORED_ACCESSIBILITY_SETTINGS_KEY = 'accessibility-settings-104abc59-c1e1-4a72-a3e3-0afe7e3ed141';
